exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".userRouter-enter-active[data-v-542bfca1]{transform:scale(1);opacity:1;-webkit-transform:rotateY(0);transform:rotateY(0);-webkit-transform-origin:50% 0 0;transform-origin:50% 0 0;transition:all .8s ease}.userRouter-enter[data-v-542bfca1]{opacity:0;-webkit-transform:rotateY(-90deg) translateZ(0);transform:rotateY(-90deg) translateZ(0);-webkit-transform-origin:50% 0 0;transform-origin:50% 0 0}.userRouter-leave-active[data-v-542bfca1]{opacity:0;-webkit-transform:rotateY(-90deg);transform:rotateY(-90deg);-webkit-transform-origin:50% 0 0;transform-origin:50% 0 0;transition:all .3s ease}.userRouter-leave[data-v-542bfca1]{opacity:1;transform:translateZ(0);-webkit-transform:translateZ(0)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-542bfca1","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/music/Music.vue
// module id = 106
// module chunks = 0